<template>
<div class="goldlist">
    <div class="gold">
       <div class="top">
           <div class="left">
               <p>当前金币：</p>
               <span>{{data.gold}}</span>
           </div>
           <div class="right">
               <p>上一笔金币（转）零钱结转</p>
               <span>{{getYesterdayGold}}金币 = {{getYesterdayDeposit}}元</span>
           </div>
       </div>
       <div class="bottom">
           <p>当前汇率：1.00元 = {{data.todayExchangeRate}}金币</p>
       </div>
    </div>
    <CashList :list="data.goldRecord" type="gold"></CashList>
</div>
</template>

<script>
import CashList from '@/components/money/item'
export default {
    name: 'goldList',
    components:{
        CashList
    },
    data () {
        return {
            data:{
                gold:0,
                yesterdayDeposit: 0,
                yesterdayGold: 0,
                todayExchangeRate: 10000,
                goldRecord: []
            }
        }
    },
    computed:{
        getYesterdayGold(){
            return this.yesterdayGold>0? this.yesterdayGold:0;
        },
        getYesterdayDeposit(){
            return this.yesterdayDeposit>0? this.yesterdayDeposit:0;
        }
    },
    filters:{
        toTwo(num){
            return num > 0 ? (Number(num) / 100).toFixed(2) : '0.00';
        }
    },
    methods: {
        fetchData(userInfo) {
            this.$http.get('/logic/wallet/withdrawInfo?fields=gold,yesterdayGold,yesterdayDeposit,todayExchangeRate,goldRecord',{params:{uuid:userInfo.uuid,sessionId:userInfo.sessionId,onlyId:userInfo.onlyId}}).then(res=>{
                this.data=res.data;
                if(this.data.yesterdayGold < 0)
                    this.data.yesterdayGold = 0;
                if(this.data.yesterdayDeposit < 0)
                    this.data.yesterdayDeposit = 0;
                this.data.goldRecord=JSON.parse(this.data.goldRecord);
            }).catch(error=>{console.log(error)});
        }
    },
    mounted(){
        let userInfo; 
        let _this = this;
        if("Android" in window) {
            userInfo = JSON.parse(Android.getUserInfo());
            _this.fetchData(userInfo)
        }else {
            window['getUserInfo'] = function(data) {
                userInfo = JSON.parse(data);
                _this.fetchData(userInfo);
            };
            window.webkit.messageHandlers.getIosData.postMessage('123');
        }
    }
}
</script>

<style lang="less" scoped>
    .goldlist{
        padding: 16px 14px;
    }
   .gold{
        box-shadow: #bbb 0 0 4px;
        border-radius: 5px;
        overflow: hidden;
   }
   .gold .top{
       background-color: #ffdd4f;
       height: 108px;
       padding: 24px;
       font-size: 14px;
   }
   .gold .top .left{
       float: left;
       text-align: center;
   }
   .gold .top .right{
       float: right;
   }
   .gold .top span{
       color: #fff;
       font-size: 16px;
       margin-top: 20px;
       display: inline-block;
   }
   .gold .bottom{
       line-height: 20px;
       padding: 10px 0 10px 20px;
       text-align: left;
   }
   .gold .bottom p{
    color: #f00;
    font-size: 12px;
   }
</style>
